<div class="api-key-banner mb-3" [class.api-key-banner--set]="hasApiKey && !showForm">

  <div *ngIf="showForm" class="alert alert-warning mb-0">
    <div class="fw-semibold mb-2">
      <i class="mdi mdi-key-variant me-1"></i>
      {{ productLabel }} API Key required
    </div>

    <div class="text-muted small mb-2">
      This demo calls the {{ productLabel }} API directly with the
      <code>x-api-key</code> header.
      <ng-container *ngIf="hasPresets">Pick a key</ng-container>
      <ng-container *ngIf="!hasPresets">Paste the key</ng-container>
      to enable the flow.
    </div>

    <div class="d-flex flex-wrap gap-2">
      <select *ngIf="hasPresets" class="form-select api-key-banner__select" [ngModel]="selectedPresetKey"
        (ngModelChange)="onPresetSelected($event)">
        <option *ngFor="let preset of presets" [value]="preset.key">
          {{ preset.label }}
        </option>
        <option [value]="manualKeyOption">Enter key manually…</option>
      </select>

      <input *ngIf="showManualInput" type="password" class="form-control api-key-banner__input"
        placeholder="YOUR_API_KEY_HERE" [(ngModel)]="apiKeyInput" (keyup.enter)="saveApiKey()" autocomplete="off">

      <button *ngIf="showManualInput" class="btn btn-primary" type="button" [disabled]="!apiKeyInput?.trim()"
        (click)="saveApiKey()">
        Save Key
      </button>

      <button *ngIf="hasApiKey" class="btn btn-light" type="button" (click)="cancelEditing()">
        Cancel
      </button>
    </div>
  </div>

  <div *ngIf="hasApiKey && !showForm" class="d-flex align-items-center justify-content-end gap-2 small text-muted">
    <span>
      <i class="mdi mdi-key-variant me-1"></i>
      {{ productLabel }} API Key:
      <strong>{{ activePresetLabel || maskedApiKey }}</strong>
      <span *ngIf="activePresetLabel"> ({{ maskedApiKey }})</span>
    </span>

    <button class="btn btn-link btn-sm p-0" type="button" (click)="startEditing()">
      Change
    </button>

    <span>|</span>

    <button class="btn btn-link btn-sm p-0 text-danger" type="button" (click)="clearApiKey()">
      Remove
    </button>
  </div>

</div>